// S41: Admin Closure Requests API Endpoints
import { apiClient } from './client';

export interface ClosureRequest {
  id: string;
  user_id: string;
  user: {
    id: string;
    full_name: string;
    email: string;
    base_principal_cents: number;
    withdrawable_cents: number;
    participation_status: string;
  };
  status: 'pending' | 'processing' | 'completed' | 'cancelled';
  initiated_by: 'user' | 'admin';
  reason?: string;
  requested_at: string;
  processed_at?: string;
  cancelled_at?: string;
  exit_effective_at?: string;
  final_settlement_snapshot?: {
    base_principal_cents: number;
    withdrawable_cents: number;
    contributed_amount_cents: number;
    reinvest_percent: number;
    closure_date: string;
  };
}

export interface ClosureRequestsListResponse {
  closure_requests: ClosureRequest[];
  page: number;
  per_page: number;
  total: number;
}

export interface ClosureRequestsFilters {
  status?: 'pending' | 'processing' | 'completed' | 'cancelled';
  page?: number;
  per_page?: number;
}

export const adminClosureRequestsEndpoints = {
  // GET /api/admin/closure_requests
  getClosureRequests: async (filters?: ClosureRequestsFilters): Promise<ClosureRequestsListResponse> => {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.per_page) params.append('per_page', filters.per_page.toString());

    const queryString = params.toString();
    const url = `/api/admin/closure_requests${queryString ? `?${queryString}` : ''}`;
    
    return await apiClient.get(url);
  },

  // POST /api/admin/closure_requests/:id/approve
  approveClosureRequest: async (id: string): Promise<{ message: string; closure_request: ClosureRequest }> => {
    const response = await apiClient.post(`/api/admin/closure_requests/${id}/approve`);
    return response.data;
  },

  // POST /api/admin/closure_requests/:id/reject
  rejectClosureRequest: async (id: string, reason?: string): Promise<{ message: string; closure_request: ClosureRequest }> => {
    const response = await apiClient.post(`/api/admin/closure_requests/${id}/reject`, { reason });
    return response.data;
  },

  // DELETE /api/admin/closure_requests/:id/cancel
  cancelClosureRequest: async (id: string): Promise<{ message: string; closure_request: ClosureRequest }> => {
    const response = await apiClient.delete(`/api/admin/closure_requests/${id}/cancel`);
    return response.data;
  },
};
